import { ObservationType } from '@interfaces-clean/observations.interface';
import ControlsReviewLogsApi from '@apis/bff-api/central-monitoring/controls-review-log';
import SiteReviewLogsApi from '@apis/bff-api/central-monitoring/site-review-log';
import StudyReviewLogsApi from '@apis/bff-api/central-monitoring/study-review-log';

export function useAssociatedReviewLogs(
    type: ObservationType,
    studyRef: string | null,
    observationId: string | undefined,
) {
    if (type === ObservationType.Controls) {
        return ControlsReviewLogsApi.useLookupReviewLogsForObservation(studyRef || '', observationId || '', type);
    }
    if (type === ObservationType.Study) {
        return StudyReviewLogsApi.useLookupReviewLogsForObservation(studyRef || '', observationId || '', type);
    }
    if (type === ObservationType.Site) {
        return SiteReviewLogsApi.useLookupReviewLogsForObservation(studyRef || '', observationId || '', type);
    }
    return { data: null, isLoading: false };
}
